import { Box, HStack, Text, VStack } from 'native-base';
import React, { Fragment } from 'react';

import GroupTitle from 'app/components/ProductLineup/GroupTitle';
import LineupAttraction from 'app/components/ProductLineup/LineupAttraction';
import { ProductContent } from 'app/hooks/useProduct';
import useReservationTextTranslationHelper from 'app/hooks/useReservationTextTranslationHelper';
import { useI18n } from 'app/providers/I18nProvider';
import {
  Entitlement,
  ProductLineup as IProductLineup,
} from 'app/services/GuestCenterService.types';
import { createAppProductLineup, getDetailsTitle } from 'app/services/ProductLineupHelper';
import { tID } from 'app/services/TestHelper';

export type ProductLineupProps = {
  productLineup: IProductLineup;
  productContent: ProductContent;
  entitlement: Entitlement | undefined;
};

export default function ProductLineup({
  productLineup,
  productContent,
  entitlement,
}: ProductLineupProps) {
  const { locale, t } = useI18n();
  const rt = useReservationTextTranslationHelper({
    product: productContent,
  });
  const appProductLineup = createAppProductLineup({
    productLineup,
    productContentLineups: productContent.attractionLineups,
    entitlement,
  });
  const lineupDetailsTitle = getDetailsTitle(appProductLineup, { rt, entitlement, locale });

  return (
    <VStack space="4" testID={tID('ProductLineup')}>
      {!!lineupDetailsTitle && <GroupTitle>{lineupDetailsTitle}</GroupTitle>}

      {appProductLineup.attractionGroups.map((group) => {
        const title = group.getTitle({ rt, productContent });
        const titleSuffix = group.getTitleSuffix({ t, locale, productContent });

        return (
          <VStack key={group.key} space="4">
            {!!title && (
              <GroupTitle>
                {title} {titleSuffix}
              </GroupTitle>
            )}

            {group.cards.map((card) => (
              <Box key={card.key} bgColor="white" rounded="md" shadow="1" testID="AttractionCard">
                {card.attractions.map((lineupAttraction, i) => (
                  <Fragment key={`${lineupAttraction.key}_frag`}>
                    {i % 2 !== 0 && <Or key={`${lineupAttraction.key}_or`} />}
                    <LineupAttraction
                      key={lineupAttraction.key}
                      card={card}
                      group={group}
                      lineupAttraction={lineupAttraction}
                      productContent={productContent}
                    />
                  </Fragment>
                ))}
              </Box>
            ))}
          </VStack>
        );
      })}
    </VStack>
  );
}

function Or() {
  const { t } = useI18n();

  return (
    <HStack alignItems="center" justifyContent="center" mx="4">
      <Box borderColor="brand.border" borderTopWidth="1" flexGrow="1" />
      <Text bold px="2" textTransform="uppercase">
        {t('gen_or')}
      </Text>
      <Box borderColor="brand.border" borderTopWidth="1" flexGrow="1" />
    </HStack>
  );
}
